import React from 'react'
import { ControlledModal, ModalTitle } from '../../layouts/components/modal'
import { Logo } from '../../components/simple/logo'
import { useTranslation } from '../../providers/translation'
import { mapWithDividerSimple } from '../../utils'
import { IconAngleRight } from '../../icons/library'
import { makeRequest, showAxiosErrorAsToast } from '../../request'
import { User } from '../../providers/context'
import { useShowWithPriority } from '../../providers/modalPriorityProvider'

export const UnreadSystemMessageModal: React.FC<{
  messages: NonNullable<User['unreadSystemMessages']>
}> = ({ messages }) => {
  const { tr } = useTranslation()
  const { active, onComplete } = useShowWithPriority(900)

  return (
    <ControlledModal
      size="md"
      onOpenChange={(o) => {
        if (o) return
        onComplete()
        makeRequest('/frontend_api/markAllRead', {
          read: true,
          messageIDs: messages.map((m) => m.id),
        }).catch(showAxiosErrorAsToast)
      }}
      open={active}
    >
      <div className="flex items-center gap-2">
        <Logo />
        <ModalTitle className="mr-4 text-xl font-bold">{tr('Unread System Updates')}</ModalTitle>
      </div>

      {mapWithDividerSimple(messages, (item, index) => (
        <div className="mb-3 flex flex-col gap-2" key={index}>
          <div className="flex items-center">
            <IconAngleRight className="mr-2 text-logo" size="lg" />
            <div className="text-2xl">{item.subject}</div>
          </div>
          <div className="ml-1" dangerouslySetInnerHTML={{ __html: item.content }} />
        </div>
      ))}
    </ControlledModal>
  )
}
